<template>
  <div>
    <SettingsSection :title="$t('platform.card.sections.main_title')">
      <NameField v-model="form.name" :v="v.name" />
      <PaymentModelField v-if="kind !== 'directlink'" :value="form.payment_model" readonly />
      <SettingsField v-if="isSite && subaccount.url" :label="$t('platform.create.url')" :hint="$t('platform.card.fields.url')" readonly :readonlyValue="subaccount.url" />
      <SettingsField v-if="isSite" :label="$t('category')" :hint="$t('platform.card.fields.category')" readonly :readonlyValue="form.category_id && form.category_id.title" />
    </SettingsSection>

    <VerificationSection v-if="isSite && subaccount.url" :subaccount="subaccount" />

    <SettingsSection v-if="isSite || showFeeds" :title="$t('platform.card.sections.ads_title')" :description="$t('platform.card.sections.ads')">
      <SettingsField v-if="isSite" :label="$t('platform.card.fields.adult_title')" :hint="$t('platform.card.fields.adult')">
        <CheckBoxWrapper v-model="form.adult" :text="$t('platform.site.show_for_adult')" />
      </SettingsField>
      <DisabledCategoriesField v-if="isSite && form.payment_model.value !== 1" v-model="form.disabledCategory" :categories="options.disabledCategories" />
      <SettingsField v-if="showFeeds" :label="$t('platform.sales_on_feeds')" :hint="$t('platform.card.fields.feeds')">
        <CheckBoxWrapper v-model="form.feedsSales" :text="$t(form.feedsSales ? 'platform.card.on' : 'platform.card.off')" />
      </SettingsField>
    </SettingsSection>
  </div>
</template>
<script>
import CheckBoxWrapper from "@/components/CheckBoxWrapper.vue";
import SettingsField from "@/components/PlatformCard/SettingsField.vue";
import SettingsSection from "@/components/PlatformCard/SettingsSection.vue";
import NameField from "@/components/PlatformCard/fields/NameField.vue";
import PaymentModelField from "@/components/PlatformCard/fields/PaymentModelField.vue";
import DisabledCategoriesField from "@/components/PlatformCard/fields/DisabledCategoriesField.vue";
import VerificationSection from "@/components/PlatformCard/VerificationSection.vue";
import { isSiteKind, KIND_DIRECTLINK } from "@/components/PlatformCard/subaccountPayload";

// The name of a platform, what was fixed at its creation, and which ads it shows.
export default {
  name: "GeneralTab",
  components: { CheckBoxWrapper, SettingsField, SettingsSection, NameField, PaymentModelField, DisabledCategoriesField, VerificationSection },
  props: {
    form: {
      type: Object,
      required: true,
    },
    // vuelidate state of the form
    v: {
      type: Object,
      required: true,
    },
    kind: {
      type: String,
      required: true,
    },
    subaccount: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSite() {
      return isSiteKind(this.kind);
    },
    // Selling to feeds is a Revshare option
    showFeeds() {
      return this.kind !== KIND_DIRECTLINK && this.form.payment_model.value === 0;
    },
  },
};
</script>
